var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "watchlist" },
    [
      _c("SidebarTitle", { attrs: { title: _vm.title } }),
      _vm._v(" "),
      _vm._l(_vm.links, function (topic, index) {
        return _c(
          "div",
          { key: index, staticClass: "watchlist__topic" },
          [
            topic.options.length
              ? _c("SidebarTitle", {
                  attrs: { title: topic.label, size: "small" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "watchlist__links" },
              _vm._l(topic.options, function (link, index2) {
                return _c(
                  "div",
                  { key: index2, staticClass: "watchlist__link" },
                  [
                    _c("p", [
                      _vm._v("\n          " + _vm._s(link.name) + "\n        "),
                    ]),
                    _vm._v(" "),
                    _c("Button", {
                      attrs: {
                        "style-class": topic.value.some((el) => el === link.tid)
                          ? "red small upper"
                          : "blue small upper",
                        text: topic.value.some((el) => el === link.tid)
                          ? "watching"
                          : "watch",
                      },
                      on: {
                        clickButton: function ($event) {
                          _vm.changeStatus(
                            topic.name,
                            topic.value.some((el) => el === link.tid),
                            link.tid,
                            link.name
                          )
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }